export const primaryProps = ({ primary, theme }: any) =>
  primary &&
  `
  color: ${theme.colors.palette.primary[50]}
`;
